/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "../route";

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<RouterProvider router={router}/>);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
